export default "__VITE_ASSET__BbVQBBiZ__"